import thunk from 'redux-thunk';
import LogRocket from 'logrocket';
import { createEpicMiddleware } from 'redux-observable';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
// ---- external imports ----

import epics from './epics';
import { rootReducer } from './reducers';
// ---- internal imports ----

const observableMiddleware = createEpicMiddleware();
const ignoredPaths = [
	'employees.allEmployees',
	'level.levelList',
	'logbook.logsByDate',
	'logbook.systemLogsByDate',
	'ads.availableAds',
	'financialStatements.statementsByQuarterNum',
	'financialStatements.systemStatementsByQuarterNum',
	'financialStatements.openingInventoryByQuarterNum',
	'financialStatements.lostInventoryByQuarterNum',
	'hints.hintsList',
	'cars.allCars',
	'warehouses.allWarehouses',
];

const defaultMiddleware = getDefaultMiddleware({
	immutableCheck: {
		ignoredPaths: ignoredPaths,
	},
	serializableCheck: {
		ignoredPaths: ignoredPaths,
	},
});

const middleware = [...defaultMiddleware, observableMiddleware, thunk, LogRocket.reduxMiddleware()];

const store = configureStore({
	reducer: rootReducer,
	middleware,
	devTools: process.env.NODE_ENV !== 'production',
});

observableMiddleware.run(epics);


export default store;

export * from './selectors';
export * from './actions';
